import { Action, createAction } from 'redux-act';

import Place from '../../../models/interfaces/Place';
import TimestampPayload from '../TimestampPayload';

export interface UpdatePlacePayload extends TimestampPayload {
  place: Place;
}
export const updatePlace = createAction<UpdatePlacePayload>('UPDATE_PLACE');
export type UpdatePlaceActionType = Action<UpdatePlacePayload>;

export interface PlaceUpdatedPayload extends TimestampPayload {
  place: Place;
}
export const placeUpdated = createAction<PlaceUpdatedPayload>('PLACE_UPDATED');

export interface PlaceUpdateFailedPayload extends TimestampPayload {
  placeUuid: string;
}
export const placeUpdateFailed = createAction<PlaceUpdateFailedPayload>('PLACE_UPDATE_FAILED');
